import { render, staticRenderFns } from "./ZoneShowData.vue?vue&type=template&id=2e149560"
import script from "./ZoneShowData.vue?vue&type=script&lang=js"
export * from "./ZoneShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports